import { render, staticRenderFns } from "./energySavingSpace.vue?vue&type=template&id=51f86277&scoped=true"
import script from "./energySavingSpace.vue?vue&type=script&lang=js"
export * from "./energySavingSpace.vue?vue&type=script&lang=js"
import style0 from "./energySavingSpace.vue?vue&type=style&index=0&id=51f86277&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f86277",
  null
  
)

export default component.exports